const swappedFilterRow = element => {
    if (element.matches?.('.search-filter')) {
        return element;
    }

    return element.matches?.('.search-filter-rows') ? element.lastElementChild : null;
};

export const focusFilterInput = element => {
    const row = swappedFilterRow(element);

    if (!row) {
        return;
    }

    const input = row.querySelector('.search-filter-key input')
        ?? [...row.querySelectorAll('.search-filter-value input')].find(field => field.checkVisibility());

    if (input) {
        input.focus();

        return;
    }

    row.querySelector('.search-filter-value-select')?.open();
};

export const removeFilterRow = button => {
    const row = button.closest('.search-filter');
    const form = row.closest('form.search-filters');
    const values = row.querySelectorAll('.search-filter-value input, .search-filter-value-select select');
    const wasApplied = [...values].some(value => value.value.trim() !== '');

    row.remove();

    if (wasApplied) {
        form.dispatchEvent(new Event('change', {bubbles: true}));
    }
};
